import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";

/**
 * Hook to detect when client-side hydration is complete
 * Useful for preventing SSR/client mismatch errors
 */
export function useClientHydration() {
  const $ = _c(2);
  const [isClientLoaded, setIsClientLoaded] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsClientLoaded(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isClientLoaded;
}